import { Image, X } from 'lucide-react';
import { useState } from 'react';

export default function Gallery() {
  const [showFullGallery, setShowFullGallery] = useState(false);

  const galleryItems = [
    // Academic Support
    { id: 1, title: 'Homework Guidance', image: '01.png', category: 'Academic Support' },
    { id: 2, title: 'Learning Games', image: 'children.png', category: 'Academic Support' },
    { id: 3, title: 'Focus & Achievement', image: 'GIRL1.png', category: 'Academic Support' },
    { id: 4, title: 'Interactive Learning', image: '89.png', category: 'Academic Support' },
    { id: 5, title: 'Study Session', image: '123.png', category: 'Academic Support' },
    { id: 6, title: 'Group Learning', image: '22.png', category: 'Academic Support' },
    { id: 7, title: 'Class Activity', image: '456.png', category: 'Academic Support' },
    { id: 8, title: 'Reading Time', image: '87.png', category: 'Academic Support' },
    { id: 9, title: 'Study Group', image: 'tothid.png', category: 'Academic Support' },
    
    // Skill Development - Vedic Maths
    { id: 10, title: 'Vedic Math Sessions', image: 'vedic.png', category: 'Skill Development - Vedic Maths' },
    { id: 11, title: 'Math Learning', image: 'abacus.png', category: 'Skill Development - Vedic Maths' },
    { id: 12, title: 'Practice Session', image: '789.png', category: 'Skill Development - Vedic Maths' },
    
    // Skill Development - Public Speaking
    { id: 13, title: 'Public Speaking', image: 'BOY3.png', category: 'Skill Development - Public Speaking' },
    { id: 14, title: 'Creative Time', image: '693.png', category: 'Skill Development - Public Speaking' },
    
    // Skill Development - Handwriting
    { id: 15, title: 'Handwriting Practice', image: 'pencil-.png', category: 'Skill Development - Handwriting' },
    { id: 16, title: 'Cursive Writing', image: 'write.png', category: 'Skill Development - Handwriting' },
    { id: 17, title: 'Writing Practice', image: 'hand.png', category: 'Skill Development - Handwriting' },
    
    // Skill Development - Art & Craft
    { id: 18, title: 'Art & Craft', image: 'artist.png', category: 'Skill Development - Art & Craft' },
    
    // Skill Development - Phonics
    { id: 19, title: 'Phonics Learning', image: 'Early-Literacy-Screening.jpg', category: 'Skill Development - Phonics' },
    
    // General
    { id: 20, title: 'Child Learning', image: 'child-hero.png', category: 'General' },
    { id: 21, title: 'Young Learner', image: 'lil-girl.png', category: 'General' },
    { id: 22, title: 'Learning Activities', image: '11111.png', category: 'General' },
  ];

  // Preview items - one per category
  const previewItems = [
    galleryItems.find(item => item.category === 'Academic Support'),
    galleryItems.find(item => item.category === 'Skill Development - Vedic Maths'),
    galleryItems.find(item => item.category === 'Skill Development - Public Speaking'),
    galleryItems.find(item => item.category === 'Skill Development - Handwriting'),
    galleryItems.find(item => item.category === 'Skill Development - Art & Craft'),
    galleryItems.find(item => item.category === 'Skill Development - Phonics'),
    galleryItems.find(item => item.category === 'General'),
  ];

  return (
    <section id="gallery" className="py-16 sm:py-24 bg-pink-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold font-display text-purple-dark mb-4">
            Our <span className="text-purple-primary">Gallery</span>
          </h2>
          <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto">
            A glimpse into our colorful world of learning and fun
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {previewItems.map((item) => (
            <div
              key={item.id}
              className="group relative bg-gradient-to-br from-purple-primary/10 to-pink-light/30 rounded-2xl overflow-hidden shadow-soft hover:shadow-lg transition-all duration-300 aspect-square cursor-pointer"
            >
              <img
                src={`/gallery/${item.image}`}
                alt={item.title}
                className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="w-full p-4 sm:p-6">
                  <p className="text-white font-semibold text-sm sm:text-base">{item.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12 sm:mt-16">
          <button onClick={() => setShowFullGallery(true)} className="bg-purple-primary hover:bg-purple-dark text-white px-8 sm:px-10 py-3 sm:py-4 rounded-2xl font-semibold text-base sm:text-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 mx-auto">
            <Image size={20} />
            View Full Gallery
          </button>
        </div>

        {/* Full Gallery Modal */}
        {showFullGallery && (
          <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl max-w-6xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
              {/* Header */}
              <div className="sticky top-0 bg-gradient-to-r from-purple-primary to-purple-dark p-6 sm:p-8 flex items-center justify-between">
                <h2 className="text-2xl sm:text-3xl font-bold text-white font-display">
                  Our Gallery
                </h2>
                <button
                  onClick={() => setShowFullGallery(false)}
                  className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors flex-shrink-0"
                >
                  <X size={28} />
                </button>
              </div>

              {/* Gallery Content */}
              <div className="p-6 sm:p-8">
                {/* Academic Support Section */}
                <div className="mb-12">
                  <h3 className="text-2xl font-bold text-purple-primary mb-6 flex items-center gap-2">
                    <span className="w-1 h-8 bg-purple-primary rounded-full"></span>
                    Academic Support
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {galleryItems
                      .filter(item => item.category === 'Academic Support')
                      .map(item => (
                        <div key={item.id} className="group relative bg-gradient-to-br from-purple-primary/10 to-pink-light/30 rounded-2xl overflow-hidden shadow-soft hover:shadow-lg transition-all duration-300 aspect-square">
                          <img
                            src={`/gallery/${item.image}`}
                            alt={item.title}
                            className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                            <div className="w-full p-4 sm:p-6">
                              <p className="text-white font-semibold text-sm sm:text-base">{item.title}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                {/* Vedic Maths Section */}
                <div className="mb-12">
                  <h3 className="text-2xl font-bold text-blue-600 mb-6 flex items-center gap-2">
                    <span className="w-1 h-8 bg-blue-600 rounded-full"></span>
                    Vedic Mathematics
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {galleryItems
                      .filter(item => item.category === 'Skill Development - Vedic Maths')
                      .map(item => (
                        <div key={item.id} className="group relative bg-gradient-to-br from-blue-100 to-blue-50 rounded-2xl overflow-hidden shadow-soft hover:shadow-lg transition-all duration-300 aspect-square">
                          <img
                            src={`/gallery/${item.image}`}
                            alt={item.title}
                            className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                            <div className="w-full p-4 sm:p-6">
                              <p className="text-white font-semibold text-sm sm:text-base">{item.title}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                {/* Public Speaking Section */}
                <div className="mb-12">
                  <h3 className="text-2xl font-bold text-yellow-600 mb-6 flex items-center gap-2">
                    <span className="w-1 h-8 bg-yellow-600 rounded-full"></span>
                    Public Speaking & Conversation
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {galleryItems
                      .filter(item => item.category === 'Skill Development - Public Speaking')
                      .map(item => (
                        <div key={item.id} className="group relative bg-gradient-to-br from-yellow-100 to-yellow-50 rounded-2xl overflow-hidden shadow-soft hover:shadow-lg transition-all duration-300 aspect-square">
                          <img
                            src={`/gallery/${item.image}`}
                            alt={item.title}
                            className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                            <div className="w-full p-4 sm:p-6">
                              <p className="text-white font-semibold text-sm sm:text-base">{item.title}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                {/* Handwriting Section */}
                <div className="mb-12">
                  <h3 className="text-2xl font-bold text-pink-600 mb-6 flex items-center gap-2">
                    <span className="w-1 h-8 bg-pink-600 rounded-full"></span>
                    Cursive Handwriting Learning
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {galleryItems
                      .filter(item => item.category === 'Skill Development - Handwriting')
                      .map(item => (
                        <div key={item.id} className="group relative bg-gradient-to-br from-pink-100 to-pink-50 rounded-2xl overflow-hidden shadow-soft hover:shadow-lg transition-all duration-300 aspect-square">
                          <img
                            src={`/gallery/${item.image}`}
                            alt={item.title}
                            className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                            <div className="w-full p-4 sm:p-6">
                              <p className="text-white font-semibold text-sm sm:text-base">{item.title}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                {/* Art & Craft Section */}
                <div className="mb-12">
                  <h3 className="text-2xl font-bold text-purple-600 mb-6 flex items-center gap-2">
                    <span className="w-1 h-8 bg-purple-600 rounded-full"></span>
                    Art & Craft
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {galleryItems
                      .filter(item => item.category === 'Skill Development - Art & Craft')
                      .map(item => (
                        <div key={item.id} className="group relative bg-gradient-to-br from-purple-100 to-purple-50 rounded-2xl overflow-hidden shadow-soft hover:shadow-lg transition-all duration-300 aspect-square">
                          <img
                            src={`/gallery/${item.image}`}
                            alt={item.title}
                            className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                            <div className="w-full p-4 sm:p-6">
                              <p className="text-white font-semibold text-sm sm:text-base">{item.title}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                {/* Phonics Section */}
                <div className="mb-12">
                  <h3 className="text-2xl font-bold text-green-600 mb-6 flex items-center gap-2">
                    <span className="w-1 h-8 bg-green-600 rounded-full"></span>
                    Phonics Sound Learning
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {galleryItems
                      .filter(item => item.category === 'Skill Development - Phonics')
                      .map(item => (
                        <div key={item.id} className="group relative bg-gradient-to-br from-green-100 to-green-50 rounded-2xl overflow-hidden shadow-soft hover:shadow-lg transition-all duration-300 aspect-square">
                          <img
                            src={`/gallery/${item.image}`}
                            alt={item.title}
                            className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                            <div className="w-full p-4 sm:p-6">
                              <p className="text-white font-semibold text-sm sm:text-base">{item.title}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                {/* General Section */}
                <div className="mb-12">
                  <h3 className="text-2xl font-bold text-gray-700 mb-6 flex items-center gap-2">
                    <span className="w-1 h-8 bg-gray-700 rounded-full"></span>
                    Other Moments
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {galleryItems
                      .filter(item => item.category === 'General')
                      .map(item => (
                        <div key={item.id} className="group relative bg-gradient-to-br from-gray-100 to-gray-50 rounded-2xl overflow-hidden shadow-soft hover:shadow-lg transition-all duration-300 aspect-square">
                          <img
                            src={`/gallery/${item.image}`}
                            alt={item.title}
                            className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                            <div className="w-full p-4 sm:p-6">
                              <p className="text-white font-semibold text-sm sm:text-base">{item.title}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                {/* Close Button */}
                <div className="text-center mt-12">
                  <button
                    onClick={() => setShowFullGallery(false)}
                    className="bg-purple-primary hover:bg-purple-dark text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300"
                  >
                    Close Gallery
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
